module.exports = __webpack_public_path__ + "img/sort11.a8f274bd.jpg";